export function isFunction(val) {
  return typeof val === 'function';
}
export const isNumber = value => typeof value === 'number' && !isNaN(value);
export const isNil = value => value == null;
const htmlRegex = new RegExp(/^<\/?[a-z][\s\S]*>/, 'i');
export const isHtml = value => {
  return typeof value === 'string' && htmlRegex.test(value);
};